
var filter_count = document.querySelectorAll('.filter-wrap input:checked:not(.price-left):not(.price-right)').length;
var count = 0 + filter_count ;
var maxval = parseInt( document.querySelector('.price-right').getAttribute('max') )
      var maxinpuval = parseInt(document.querySelector('.price-right').value)
      var minval = parseInt( document.querySelector('.price-left').getAttribute('min') )
      var mininpuval = parseInt(document.querySelector('.price-left').value)
       var filter_count = document.querySelectorAll('.filter-wrap input:checked:not(.price-left):not(.price-right)').length;
    let facetList =   document.querySelector('.multi-range-slider').closest('.facet-list');
      let countbox =  facetList.querySelector('.inner_filter_count');
      countbox.innerHTML = '';
      if((maxval != maxinpuval) || (minval != mininpuval)){
      filter_count = filter_count + 1;
        countbox.innerHTML = '(1)';
      }
const facetLists = document.querySelectorAll('.facet-list.filter-index');
    facetLists.forEach(function(facetList, index) {
    let countbox =  facetList.querySelector('.inner_filter_count');
    const checkedInputs = facetList.querySelectorAll('input:checked');
    const length = checkedInputs.length;
       if (length == 0){
    countbox.innerHTML = "";
    }
      else{
        countbox.innerHTML = '(' + length + ')';
      }
});

function get_value () {
  let allCheckBox = document.querySelectorAll('.filter-wrap input:not(.price-left):not(.price-right)');
  allCheckBox.forEach((checkbox) => { 
  checkbox.addEventListener('change', (event) => {


const facetList = checkbox.closest('.facet-list.filter-index'); 
let countbox =  facetList.querySelector('.inner_filter_count');
const checkedInputs = facetList.querySelectorAll('input:checked');
const length = checkedInputs.length;
   if (length == 0){
    countbox.innerHTML = "";
    }
      else{
        countbox.innerHTML = '(' + length + ')';
      }


    if (event.target.checked) {
      checkbox.setAttribute("checked","");
       count++;
    }
    else{
      checkbox.removeAttribute("checked","");
       count--;
    }
    document.querySelectorAll('.filter_count').forEach(function(self){
          if (count != 0) {
            self.innerHTML = '(' + count + ')';
          } else {
            self.innerHTML = '';
        }
      });
  })
})

  let pricefilter = document.querySelectorAll('.filter-wrap input[type="range"]');
   pricefilter.forEach((checkbox) => {
      checkbox.addEventListener('change', (event) => {
      var maxval = parseInt( document.querySelector('.price-right').getAttribute('max') )
      var maxinpuval = parseInt(document.querySelector('.price-right').value)
      var minval = parseInt( document.querySelector('.price-left').getAttribute('min') )
      var mininpuval = parseInt(document.querySelector('.price-left').value)
var filter_count = document.querySelectorAll('.filter-wrap input:checked:not(.price-left):not(.price-right)').length;    

    var filter_count = document.querySelectorAll('.filter-wrap input:checked:not(.price-left):not(.price-right)').length;
    let facetList =   document.querySelector('.multi-range-slider').closest('.facet-list');
      let countbox =  facetList.querySelector('.inner_filter_count');
      countbox.innerHTML = '';
        
      if((maxval != maxinpuval) || (minval != mininpuval)){
        
count = filter_count + 1;
        countbox.innerHTML = '(1)';
      }
      
          document.querySelectorAll('.filter_count').forEach(function(self){
          if (count != 0) {
            self.innerHTML = '(' + count + ')';
          } else {
            self.innerHTML = '';
        }
      });
        
      })
   })
}
get_value();




class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
      document.querySelector('body').classList.remove('open-filter','open-sort');
      typeof infinitescroll == 'object' && typeof infinitescroll?.scolljs == 'function' && infinitescroll?.scolljs()
    }, 500);
      //this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
      const applyfilter = this.querySelector('.apply-filter');
      if (applyfilter) applyfilter.addEventListener('click', this.debouncedOnSubmit.bind(this));    
      const filterbtn = this.querySelector('.filter-button');
      const sortbtn = this.querySelector('.sort-button');
      if (filterbtn) filterbtn.addEventListener('click',function(e){
      document.querySelector('body').classList.toggle('open-filter');
      document.querySelector('body').classList.remove('open-sort','open-drawer','open-menu','open-search');
    });    
      if (sortbtn) sortbtn.addEventListener('click',function(e){
      document.querySelector('body').classList.toggle('open-sort');
      document.querySelector('body').classList.remove('open-filter','open-drawer','open-menu','open-search');
    });
      if(document.querySelector('.sort-box')){
      document.querySelector('.sort-box').addEventListener('input', this.debouncedOnSubmit.bind(this));
    }

    var filter_count = document.querySelectorAll('.filter-wrap input:checked:not(.price-left):not(.price-right)').length;
    let facetList =   document.querySelector('.multi-range-slider').closest('.facet-list');
      let countbox =  facetList.querySelector('.inner_filter_count');
      countbox.innerHTML = '';
    var maxval = parseInt( document.querySelector('.price-right').getAttribute('max') )
    var maxinpuval = parseInt(document.querySelector('.price-right').value)
    var minval = parseInt( document.querySelector('.price-left').getAttribute('min') )
    var mininpuval = parseInt(document.querySelector('.price-left').value)

    if((maxval != maxinpuval) || (minval != mininpuval)){
      filter_count = filter_count + 1;
       countbox.innerHTML = '(1)';
    } 

        document.querySelectorAll('.filter_count').forEach(function(self){
          if (filter_count != 0) {
            self.innerHTML = '(' + filter_count + ')';
            self.parentNode.classList.add('active');
          } else {
            self.innerHTML = '';
            self.parentNode.classList.remove('active');
        }
      });

const facetLists = document.querySelectorAll('.facet-list.filter-index');
    facetLists.forEach(function(facetList, index) {
    let countbox =  facetList.querySelector('.inner_filter_count');
    const checkedInputs = facetList.querySelectorAll('input:checked');
    const length = checkedInputs.length;
    if (length == 0){
     countbox.innerHTML = "";
    }else{
      countbox.innerHTML = '(' + length + ')';
    }
});

    
    }
  static setListeners() {
      const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }
  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;
      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
      FacetFiltersForm.renderSectionFromFetch(url, event);
    });
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }
  static renderSectionFromFetch(url, event) {
    fetch(url)
    .then(response => response.text())
    .then((responseText) => {
      const html = responseText;
      FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
      FacetFiltersForm.renderFilters(html, event);
      FacetFiltersForm.renderProductGridContainer(html);
      // filter total count get
      let filter_count = document.querySelectorAll('.filter-wrap input:checked:not(.price-left):not(.price-right)').length;
      // console.log(filter_count)
      let facetList =   document.querySelector('.multi-range-slider').closest('.facet-list');
      let countbox =  facetList.querySelector('.inner_filter_count');
      countbox.innerHTML = '';
      var maxval = Number( document.querySelector('.price-right').getAttribute('max') )
      var maxinpuval = Number(document.querySelector('.price-right').value)
      var minval = Number( document.querySelector('.price-left').getAttribute('min') )
      var mininpuval = Number(document.querySelector('.price-left').value)
      
      if((maxval != maxinpuval) || (minval != mininpuval)){
      filter_count = filter_count + 1;
      
      countbox.innerHTML = '(1)';
      } 
      
      document.querySelectorAll('.filter_count').forEach(function(self){
        if (filter_count != 0) {
          self.innerHTML = '(' + filter_count + ')';
          self.parentNode.classList.add('active');
        } else {
          self.innerHTML = '';
          self.parentNode.classList.remove('active');
        }
      });
      // filter total count get

    const facetLists = document.querySelectorAll('.facet-list.filter-index');
    facetLists.forEach(function(facetList, index) {
    let countbox =  facetList.querySelector('.inner_filter_count');
    const checkedInputs = facetList.querySelectorAll('input:checked');
    const length = checkedInputs.length;
    if (length == 0){
    countbox.innerHTML = "";
    }
      else{
        countbox.innerHTML = '(' + length + ')';
    }
});
      
      //FacetFiltersForm.renderActiveFilter(html);
      typeof infinitescroll == 'object' && typeof infinitescroll?.scolljs == 'function' && infinitescroll?.scolljs()
      if(typeof quickAddButton == 'function'){
        quickAddButton();
      }
      get_value();

      document.querySelectorAll('.snippet-promo-image.half_img').forEach(function(i,e){
      let height = document.querySelector('.product-item img').height;
      i.style.height = height + 'px';
      });

      var scroll = $(window).scrollTop();
      if (scroll >= 100) {
        $('.collection_filter_btn.mobile').addClass('active')
      }else{
        $('.collection_filter_btn.mobile').removeClass('active')
      }
      
    });
    }
      static renderSectionFromCache(filterDataUrl, event) {
      const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
      FacetFiltersForm.renderFilters(html, event);
      FacetFiltersForm.renderProductGridContainer(html);
      //FacetFiltersForm.renderActiveFilter(html);
      if(typeof quickAddButton == 'function'){
        quickAddButton();
      }
          document.querySelectorAll('.snippet-promo-image.half_img').forEach(function(i,e){
      let height = document.querySelector('.product-item img').height;
      i.style.height = height + 'px';
      });

      var scroll = $(window).scrollTop();
      if (scroll >= 100) {
        $('.collection_filter_btn.mobile').addClass('active')
      }else{
        $('.collection_filter_btn.mobile').removeClass('active')
      }
    }
      static renderProductGridContainer(html) {
      document.getElementById('collection-grid').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('collection-grid').innerHTML;
      document.getElementById('collection_pro_count').innerText = new DOMParser().parseFromString(html, 'text/html').getElementById('collection_pro_count').innerText;
    }
      static renderFilters(html, event) {
      const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
      const facetDetailsElements =
        parsedHTML.querySelectorAll('.filter-index');
      const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.filter-index') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    facetsToRender.forEach((element) => {
      document.querySelector(`.filter-index[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;

       $( ".facet-list ul" ).each(function() {
         var li =  $(this).find('li').length
         var dis = $(this).find('.disable-facet').length
    
        if(li == dis){
          $(this).closest('.facet-list').addClass('hide_main')
        }else{
          $(this).closest('.facet-list').removeClass('hide_main')
        }
      });
      
    });
  }
  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }
  static getSections() {
    return [
      {
        section: document.getElementById('collection-grid').dataset.id,
      }
    ]
  }
  
  onSubmitHandler(event) {    
    
    const  filterCheck=(params)=> {
      return params.match(/filter/g).length
   }
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    let searchParams = new URLSearchParams(formData).toString();
    const result = filterCheck(searchParams);

  // filter total count get
      let filter_count = document.querySelectorAll('.filter-wrap input:checked:not(.price-left):not(.price-right)').length;
      // console.log(filter_count)
      let facetList =   document.querySelector('.multi-range-slider').closest('.facet-list');
      let countbox =  facetList.querySelector('.inner_filter_count');
      countbox.innerHTML = '';
      var maxval = Number( document.querySelector('.price-right').getAttribute('max') )
      var maxinpuval = Number(document.querySelector('.price-right').value)
      var minval = Number( document.querySelector('.price-left').getAttribute('min') )
      var mininpuval = Number(document.querySelector('.price-left').value)
      
      if((maxval != maxinpuval) || (minval != mininpuval)){
      filter_count = filter_count + 1;
      
      countbox.innerHTML = '(1)';
      } 
      
      document.querySelectorAll('.filter_count').forEach(function(self){
        if (filter_count != 0) {
          self.innerHTML = '(' + filter_count + ')';
          self.parentNode.classList.add('active');
        } else {
          self.innerHTML = '';
          self.parentNode.classList.remove('active');
        }
      });
      // filter total count get

    
    if(!(searchParams.includes("availability"))  && filter_count > 0 ){
     searchParams = searchParams + "&filter.v.availability=1";
    // console.log("it doesnt includes", result);
    // console.log("doesn't include",searchParams, result);

    } 
    else if (result <= 3 && searchParams.includes("availability")){
      searchParams = searchParams.replace('&filter.v.availability=1', " ");
      console.log(searchParams);
      //  console.log("less than 3 & does include", result) 


    } 
     FacetFiltersForm.renderPage(searchParams, event);    
    
  }
}
FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();
function filterprice(){
  var inputLeft = document.querySelector(".price-left");
  var inputRight = document.querySelector(".price-right");
  var amountLeft = document.querySelector(".amount-left .amount-percentage");
  var amountRight = document.querySelector(".amount-right .amount-percentage");
  var thumbLeft = document.querySelector(".price-slider > .thumb.left");
  var thumbRight = document.querySelector(".price-slider > .thumb.right");
  var range = document.querySelector(".price-slider > .range");
  function setLeftValue() {
    var _this = inputLeft,
        min = parseInt(_this.min),
        max = parseInt(_this.max);
    _this.value = Math.min(parseInt(_this.value), parseInt(inputRight.value) - 1);
    var percent = ((_this.value - min) / (max - min)) * 100;
    thumbLeft.style.left = percent + "%";
    amountLeft.innerHTML = _this.value;
    range.style.left = percent + "%";
  }
  setLeftValue();
  function setRightValue() {
    var _this = inputRight,
        min = parseInt(_this.min),
        max = parseInt(_this.max);
    _this.value = Math.max(parseInt(_this.value), parseInt(inputLeft.value) + 1);
    var percent = ((_this.value - min) / (max - min)) * 100;
    thumbRight.style.right = (100 - percent) + "%";
    amountRight.innerHTML = _this.value;
    range.style.right = (100 - percent) + "%";
    _this.style.zIndex  = 3;    
  }
  setRightValue();
  inputLeft.addEventListener("input", setLeftValue);
  inputRight.addEventListener("input", setRightValue);
}
if(document.querySelector('.range-wrap')){
  filterprice();
}
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
function fnBrowserDetect(){
  let userAgent = navigator.userAgent;
  let browserName;
  if(userAgent.match(/chrome|chromium|crios/i)){
    browserName = "chrome";
  }else if(userAgent.match(/firefox|fxios/i)){
    browserName = "firefox";
  }  else if(userAgent.match(/safari/i)){
    browserName = "safari";
  }else if(userAgent.match(/opr\//i)){
    browserName = "opera";
  } else if(userAgent.match(/edg/i)){
    browserName = "edge";
  }else{
    browserName="no-browser";
  }
  document.getElementById('MainContent').classList.add(browserName);
}
fnBrowserDetect()








